if (Boolean(document.getElementById('buyers-club-section').dataset.bcChecked)) {
  if (document.getElementById('MainContent').classList.contains('page-template--cart')) {
    document.body.classList.add('animate');
    setTimeout(function(){
      document.body.classList.remove('animate');
    }, 1750);
  }
}

document.getElementById('buyers-club-toggle').addEventListener('change', (event) => {
  if (event.target.checked) {
    // add buyers club to cart
    document.getElementById('add-buyers-club').click();
  }
  else {
    // remove buyers club from cart
    document.getElementById('remove-buyers-club').click();
  
    // set cookie to remember user manually turned off buyers club toggle
    document.cookie = `bc_toggle_default_override=true; path=/; max-age=${60 * 60 * 24 * document.getElementById('buyers-club-section').dataset.bcToggleTtl};`;
  }
});
